import axios from 'axios';
import store from '../store';

const service = axios.create({
    baseURL: '/yc',
    timeout: 80000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'apikey': '66961bb4e4b041ad3e9732b3',
    }
});
service.interceptors.response.use(response => {
    if (response.data.message === 'core.security.login.unauthorized') {
        sessionStorage.removeItem('userInfo');
        store.commit('setUserInfo', {});
    }
    return Promise.resolve(response);
});

export default service;
